import React from "react";

import { useFormContext } from "react-hook-form";

import { Select } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

export const CountryField: React.FC<{ className?: string }> = ({
  className
}) => {
  const { geoData, translator } = useAppContext();
  const {
    register,
    formState: { defaultValues, errors }
  } = useFormContext();

  const country_options = geoData
    .getCountries()
    .map(country => ({ value: country.value, label: country.name }));

  return (
    <Select
      labelText={translator.t("!checkout.payment.country")}
      {...register("country_code", { required: true })}
      id="country_code"
      data-has-error={errors.country_code}
      data-id="country_code"
      data-testid="country"
      defaultValue={defaultValues?.country_code}
      isInvalid={!!errors.country_code}
      className={className}
      isRequired
    >
      {country_options.map(({ value, label }) => (
        <Select.Option key={value} value={value}>
          {label}
        </Select.Option>
      ))}
    </Select>
  );
};
